@if (isKontrakt && vacsStatus) {
  <div>
    <div class="d-flex align-items-center" [ngbTooltip]="tooltipText">
      <button class="btn btn-info" [disabled]="!canUpdateVacs || readonly"
        (click)="updateVacs()">
        <i class="fas fa-location-arrow"></i>
        {{buttonText}}
      </button>
    </div>
  </div>
}